const congratsData = [
  {
    week: 'week0',
    message: '"School of Code is about to being! Are you feeling ready?"',
  },
  {
    week: 'week1',
    message: `"Congratulations you've started on your new journey"`,
  },
  {
    week: 'week2',
    message:
      '"When things get tough remember: better days are coming. They are called Saturday and Sunday."',
  },
  {
    week: 'week3',
    message: `"Well done so far! Keep at it, you will be learning some back-end soon"`,
  },
  {
    week: 'week4',
    message: `"You're a quarter of the way through 🎊 Check out everything you've learned so far"`,
  },
  {
    week: 'week5',
    message: `"You've done over 175 hours of code !"`,
  },
  {
    week: 'week6',
    message:
      '"A good laugh and a long sleep are the two best cures for anything."',
  },
  {
    week: 'week7',
    message: '"Do something today that you future self will thank you for."',
  },
  {
    week: 'week8',
    message: `"You're half of the way through!"`,
  },
  {
    week: 'week8',
    message: `"Don't wait for your feelings to change to take the action. Take the action and your feelings will change."`,
  },
  {
    week: 'week9',
    message:
      '"You measure the size of the accomplishment by the obstacles you had to overcome to reach your goals."',
  },
  {
    week: 'week10',
    message:
      '"Review your trophies, how is your skillset growing compared to Week 1."',
  },
  {
    week: 'week11',
    message: `"You're nearly at the three month mark. Well done you've come so far, not long left!"`,
  },
  {
    week: 'week12',
    message: `"Final Projects are nearly here, you have learnt so much within an accelerated learning environment."`,
  },
  {
    week: 'week13',
    message: `"You should be starting your projects this week, make sure to plan in as much detail as possible!"`,
  },
  {
    week: 'week14',
    message: '"Have you started coding for your Final Projects yet?"',
  },
  {
    week: 'week15',
    message: `"Are you nearly at the MVP for your Final Project? Review with your group and don't forget to be agile!"`,
  },
  {
    week: 'week16',
    message: `"It is the last week! Well done on coming so far and learning so much! Review your trophies, is there any skills you want to master that you haven't yet?"`,
  },
];

export default congratsData;
